/**
 * Labstep
 *
 * @module components/Entity/Form/Create/Templatable
 * @desc Create Form for templatable entity
 */

import {
  fieldEntityName,
  fieldEntityTemplate,
} from 'labstep-web/components/Entity/Form/fields';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { FormCreateContainer as FormCreate } from 'labstep-web/core/Form/Create';
import type React from 'react';
import type { EntityFormCreateProps } from './types';

export const EntityFormCreateTemplatable: React.FC<
  EntityFormCreateProps
> = ({
  entityName,
  templateId,
  activeGroup,
  defaultValues,
  showLoaderWhileCreating,
  options,
  withName = false,
}) => {
  const fields = [];

  const body: Record<string, unknown> = {};
  if (!templateId) {
    const fieldTemplate = fieldEntityTemplate(entityName);
    fields.push({
      ...fieldTemplate,
      elementProps: {
        ...fieldTemplate.elementProps,
        params: { group_id: activeGroup?.id },
      },
    });
  } else {
    body.template_id = templateId;
    body.group_id = activeGroup?.id;
  }

  if (withName) {
    fields.push(fieldEntityName(entityName));
  }

  return (
    <ParamsStateContextProvider value={{}}>
      <FormCreate
        body={body}
        autoFocus
        entityName={entityName}
        fields={fields}
        defaultValues={defaultValues}
        options={options}
        showLoaderWhileCreating={showLoaderWhileCreating}
      />
    </ParamsStateContextProvider>
  );
};

export default withActiveGroup(EntityFormCreateTemplatable);
